// extracted by mini-css-extract-plugin
module.exports = {"form":"IBAN_form__NyUH4","input":"IBAN_input__22Bae","title":"IBAN_title__2ihIe","actions":"IBAN_actions__3DGcX","btn":"IBAN_btn__1xmRs","text":"IBAN_text__2PfLs"};